import { abbreviateState } from './abbreviateStates';

/**
 * Formats address information
 *
 * @param address1 - First line of the address
 * @param address2 - Second line of the address (optional)
 * @param city - City name
 * @param state - State name (optional)
 * @param country - Country name
 * @param zipcode - Zip code (optional)
 * @returns A formatted address string
 */
export function formatAddress(
  address1?: string | null,
  address2?: string | null | undefined,
  city?: string,
  state?: string | null | undefined,
  country?: string | null,
  zipcode?: string | null | undefined,
): string {
  const line1 = address1?.trim();
  const line2 = address2?.trim() || '';
  const cityClean = city?.trim();
  const stateClean = abbreviateState(state?.trim() || '');
  const countryClean = country?.trim() || '';
  const zipcodeClean = zipcode?.trim() || '';

  const streetAddress = [line1, line2].filter(Boolean).join(', ');
  const cityStateZip = [cityClean, stateClean, zipcodeClean]
    .filter(Boolean)
    .join(', ');
  const addressParts = [streetAddress, cityStateZip, countryClean];

  return addressParts.filter(Boolean).join(' | ');
}
